import Tippy from "@tippyjs/react";
import reviewerColor from "/src/utils/reviewerColor";
import { useToastDispatchContext } from "/src/layouts/toast/context/toastContext";
import "./ReviewersBubbles.css";

function getInitials(label = "") {
    const parts = label.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return "?";
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function ReviewersBubbles({ reviewers = [], className = "" }) {
    const toast = useToastDispatchContext();

    if (!reviewers || reviewers.length === 0) {
        return <span className="reviewers-bubbles_empty">-</span>;
    }

    const copyEmail = (email) => {
        if (!email) return;
        navigator.clipboard.writeText(email).then(() => {
            toast.success("Copy to clipboard", "You can paste this email where you need !", 5000);
        });
    };

    return (
        <div className={`reviewers-bubbles ${className}`.trim()}>
            {reviewers.map((reviewer, index) => {
                const label = reviewer.name || reviewer.email || "?";
                return (
                    <Tippy
                        key={reviewer.email || index}
                        content={
                            <div className="reviewers-bubbles_tooltip">
                                <div className="reviewers-bubbles_tooltip-name">{label}</div>
                                {reviewer.email && (
                                    <div className="reviewers-bubbles_tooltip-email">{reviewer.email}</div>
                                )}
                                {reviewer.email && (
                                    <div className="reviewers-bubbles_tooltip-hint">Click to copy email</div>
                                )}
                            </div>
                        }
                        placement="top"
                        delay={[150, 0]}
                    >
                        <div
                            className="reviewers-bubbles_item"
                            style={{ background: reviewerColor(reviewer.email || label), zIndex: reviewers.length - index }}
                            onClick={() => copyEmail(reviewer.email)}
                        >
                            {getInitials(label)}
                        </div>
                    </Tippy>
                );
            })}
        </div>
    );
}

export default ReviewersBubbles;
